import superagent from 'superagent';
import moment from 'moment';
import uuidv4 from 'uuid/v4';
import * as types from './types';
import utils from '../lib/utils';
import { userLogout, forbiddenAccess } from './auth';

const request = superagent
  .agent()
  .set('ETag', window.Config.APP_VERSION)
  .use(function (req) {
    req.on('response', function (res) {
      if (res.status === 401) {
        console.log('UnAuthorized');
        userLogout();
      } else if (res.status === 403) {
        console.log('Forbidden');
        forbiddenAccess();
      }
    });
  });

export function getAppointmentReminderStart() {
  return {
    type: types.GET_APPOINTMENT_REMINDERS_START,
  };
}

export function getAppointmentReminderSuccess(appointmentreminders) {
  console.log('appointmentreminders', appointmentreminders);
  return {
    type: types.GET_APPOINTMENT_REMINDERS_SUCCESS,
    appointmentreminders,
  };
}

export function getAppointmentReminderError(error) {
  return {
    type: types.GET_APPOINTMENT_REMINDERS_FAIL,
    error,
  };
}

export function getAppointmentReminder(id) {
  return (dispatch) => {
    dispatch(getAppointmentReminderStart());
    return request
      .get(
        `${window.Config.API_URL}/business/preferences/appointment_reminders`,
      )
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(getAppointmentReminderSuccess(resp?.body?.reminders));
        } else {
          dispatch(getAppointmentReminderError(resp));
        }
      })
      .catch((ex) => {
        dispatch(getAppointmentReminderError(ex));
      });
  };
}

export function addAppointmentReminderStart() {
  return {
    type: types.ADD_APPOINTMENT_REMINDERS_START,
  };
}

export function addAppointmentReminderSuccess(appointmentreminders) {
  console.log('appointmentreminders', appointmentreminders);
  return {
    type: types.ADD_APPOINTMENT_REMINDERS_SUCCESS,
    appointmentreminders,
  };
}

export function addAppointmentReminderError(error) {
  return {
    type: types.ADD_APPOINTMENT_REMINDERS_FAIL,
    error,
  };
}

export function addAppointmentReminder(data) {
  return (dispatch) => {
    dispatch(addAppointmentReminderStart());

    return request
      .post(
        `${window.Config.API_URL}/business/preferences/appointment_reminders`,
      )
      .send(data)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(addAppointmentReminderSuccess(resp?.body));
        } else {
          dispatch(addAppointmentReminderError(resp));
        }
      })
      .catch((ex) => {
        dispatch(addAppointmentReminderError(ex));
      });
  };
}

export function deleteAppointmentReminderStart() {
  return {
    type: types.DELETE_APPOINTMENT_REMINDERS_START,
  };
}

export function deleteAppointmentReminderSuccess(appointmentreminders) {
  console.log('appointmentreminders', appointmentreminders);
  return {
    type: types.DELETE_APPOINTMENT_REMINDERS_SUCCESS,
    appointmentreminders,
  };
}

export function deleteAppointmentReminderError(error) {
  return {
    type: types.DELETE_APPOINTMENT_REMINDERS_FAIL,
    error,
  };
}

export function deleteAppointmentReminder(data) {
  return (dispatch) => {
    dispatch(deleteAppointmentReminderStart());

    return request
      .post(
        `${window.Config.API_URL}/business/preferences/appointment_reminders`,
      )
      .send(data)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(deleteAppointmentReminderSuccess(resp?.body));
        } else {
          dispatch(deleteAppointmentReminderError(resp));
        }
      })
      .catch((ex) => {
        dispatch(deleteAppointmentReminderError(ex));
      });
  };
}

export function getConversationRemindersStart() {
  return {
    type: types.GET_CONVERSATIONS_REMINDERS_START,
  };
}

export function getConversationRemindersSuccess(conversation) {
  console.log('appointmentreminders', conversation);
  return {
    type: types.GET_CONVERSATIONS_REMINDERS_SUCCESS,
    conversation,
  };
}

export function getConversationRemindersError(error) {
  return {
    type: types.GET_CONVERSATIONS_REMINDERS_FAIL,
    error,
  };
}

export function getConversationReminders(data) {
  return (dispatch) => {
    dispatch(getConversationRemindersStart());

    return request
      .post(`${window.Config.API_URL}/livedashboard/business/reminders`)
      .send(data)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(getConversationRemindersSuccess(resp?.body));
        } else {
          dispatch(getConversationRemindersError(resp));
        }
      })
      .catch((ex) => {
        dispatch(getConversationRemindersError(ex));
      });
  };
}

export function getReminderStatsStart() {
  return {
    type: types.GET_REMINDER_STATS_START,
  };
}

export function getReminderStatsSuccess(stats) {
  console.log('stats', stats);
  return {
    type: types.GET_REMINDER_STATS_SUCCESS,
    stats,
  };
}

export function getReminderStatsError(error) {
  return {
    type: types.GET_REMINDER_STATS_FAIL,
    error,
  };
}

export function getReminderStats(businessId) {
  let no_of_days = 30;
  let startdate = moment()
    .startOf('day')
    .subtract(no_of_days, 'd');
  startdate = Math.round(new Date(startdate).getTime());
  let endDate = Math.round(new Date().getTime());
  const params = Object.assign(
    {},
    {
      start_time: startdate,
      end_time: endDate,
      business_id: businessId,
    },
  );

  return (dispatch) => {
    dispatch(getReminderStatsStart());
    return request
      .post(
        `${window.Config.API_URL}/business/dashboard/appointment_reminders_statistics`,
      )
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(getReminderStatsSuccess(resp?.body));
        } else {
          dispatch(getReminderStatsError(resp));
        }
      })
      .catch((ex) => {
        dispatch(getReminderStatsError(ex));
      });
  };
}

export function downloadReminderStart() {
  return {
    type: types.DOWNLOAD_REMINDER_START,
  };
}

export function downloadReminderSuccess(appointmentreminders) {
  console.log('appointmentreminders', appointmentreminders);
  return {
    type: types.DOWNLOAD_REMINDER_SUCCESS,
    appointmentreminders,
  };
}

export function downloadReminderError(error) {
  return {
    type: types.DOWNLOAD_REMINDER_FAIL,
    error,
  };
}

export function downloadReminder(filename) {
  return (dispatch) => {
    dispatch(downloadReminderStart());
    return request
      .get(
        `${window.Config.API_URL}/business/dashboard/appointment_reminders_statistics/report?year_month=` +
          moment().format('YYYY-MM'),
      )
      .responseType('blob')
      .then((resp) => {
        if (resp.statusCode === 200) {
          const blob = new Blob([resp.body]);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          dispatch(downloadReminderSuccess(resp?.body));
        } else {
          dispatch(downloadReminderError(resp));
        }
      })
      .catch((ex) => {
        dispatch(downloadReminderError(ex));
      });
  };
}

export function updateReminderStatusStart() {
  return {
    type: types.UPDATE_REMINDER_STATUS_START,
  };
}

export function updateReminderStatusSuccess(status) {
  return {
    type: types.UPDATE_REMINDER_STATUS_SUCCESS,
    status,
  };
}

export function updateReminderStatusError(error) {
  return {
    type: types.UPDATE_REMINDER_STATUS_FAIL,
    error,
  };
}

export function updateReminderStatus(status) {
  return (dispatch) => {
    dispatch(updateReminderStatusStart());
    return request
      .post(`${window.Config.API_URL}/livedashboard/business/reminders/status`)
      .send({
        status,
      })
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(updateReminderStatusSuccess(resp?.body));
          utils.setCookie('features', resp.body);
        } else {
          dispatch(updateReminderStatusError(resp));
        }
      })
      .catch((ex) => {
        dispatch(updateReminderStatusError(ex));
      });
  };
}

export function updateVoiceStatusStart() {
  return {
    type: types.UPDATE_REMINDER_STATUS_START,
  };
}

export function updateVoiceStatusSuccess(status) {
  return {
    type: types.UPDATE_REMINDER_STATUS_SUCCESS,
    status,
  };
}

export function updateVoiceStatusError(error) {
  return {
    type: types.UPDATE_REMINDER_STATUS_FAIL,
    error,
  };
}

export function updateVoiceStatus(status) {
  return (dispatch) => {
    dispatch(updateVoiceStatusStart());
    return request
      .post(`${window.Config.API_URL}/livedashboard/business/voice_reminders/status`)
      .send({
        status,
      })
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(updateVoiceStatusSuccess(resp?.body));
          utils.setCookie('features', resp.body);
        } else {
          dispatch(updateVoiceStatusError(resp));
        }
      })
      .catch((ex) => {
        dispatch(updateVoiceStatusError(ex));
      });
  };
}
